// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TableING_card__TqgJk {
    border-radius: 12px;
    z-index: 1;
}

.TableING_tableWrapper__AZZGh {
    width: 100%;
    overflow-x: auto;
    border-radius: 8px;
    max-height: 420px;
    min-height: 200px;
    overflow-y: scroll;
}

.TableING_mainTable__ZvPUV {
    width: 100%;
    min-width: 1200px;
    margin-bottom: 0;
    border-collapse: separate;
    border-spacing: 0;
}

.TableING_mainTable__ZvPUV thead th {
    background-color: var(--primary-blue-theme-color);
    color: #ffffff;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
    padding: 8px;
    position: sticky;
    top: 0;
    z-index: 2;
}

.TableING_mainTable__ZvPUV tbody td {
    font-size: 12px;
    text-align: center;
    vertical-align: middle;
    padding: 8px;
    white-space: nowrap;
}

.TableING_mainTable__ZvPUV tbody tr:hover td {
    background-color: #f8fbff;
}

.TableING_badge__F\\+tXV {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 10px;
    font-size: 11px;
    font-weight: 600;
}

.TableING_badgeTrue__sfcMQ {
    color: #0f9d58;
    background-color: #eafbf1;
}

.TableING_badgeFalse__1\\+NPR {
    color: #d93025;
    background-color: #fdecea;
}

.TableING_badgeValid__eSZtj {
    color: #0f9d58;
    background-color: #eafbf1;
}

.TableING_downloadBtn__7vnGC {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
}

/* =========================================
   COLUMN HEADER FILTER (Engine / Ignition Status)
========================================= */

.TableING_thFilterWrap__DVv2q {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}

.TableING_thFilterSelect__RuhKH {
    width: 100%;
    max-width: 130px;
    font-size: 11px;
    font-weight: 500;
    color: #1f2937;
    background-color: #fff;
    border: 1px solid #d7dee8;
    border-radius: 4px;
    padding: 3px 4px;
    text-transform: none;
    cursor: pointer;
}

.TableING_thFilterSelect__RuhKH:focus {
    outline: none;
    border-color: #2f7ed8;
}

/* =========================================
   PAGINATION
========================================= */

.TableING_pageRow__kTUnM {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
    padding: 10px 4px 2px;
}

.TableING_pageInfo__9cGlr {
    font-size: 12px;
    color: #6c757d;
}

.TableING_pageButtons__UnTC5 {
    display: flex;
    align-items: center;
    gap: 10px;
}

.TableING_pageCurrent__k5Wom {
    font-size: 12px;
    color: #1f2937;
    font-weight: 600;
    min-width: 48px;
    text-align: center;
}

/* =========================================
   DISCLAIMER
========================================= */

.TableING_disclaimer__JJmkT {
    margin-top: 8px;
    padding: 6px 4px 2px;
    font-size: 11px;
    font-style: italic;
    color: #9ca3af;
    text-align: right;
}

.TableING_refreshDot__TVG09 {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 6px;
    vertical-align: middle;
    animation: TableING_refreshBlink__nn\\+Cf 1s ease-in-out infinite;
}

.TableING_refreshDotGreen__CB1G5 {
    background: #28a745;
    box-shadow: 0 0 6px #28a745;
}

.TableING_refreshDotRed__rlUvF {
    background: #dc3545;
    box-shadow: 0 0 6px #dc3545;
}

@keyframes TableING_refreshBlink__nn\\+Cf {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.2; }
}

.TableING_delayGreen__tKnuZ {
    color: #28a745;
    font-weight: 600;
}

.TableING_delayRed__KxvU2 {
    color: #dc3545;
    font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/SmartCIty/ING/IngReportTable/TableING.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,iDAAiD;IACjD,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,MAAM;IACN,UAAU;AACd;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;;2CAE2C;;AAE3C;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;;2CAE2C;;AAE3C;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;;2CAE2C;;AAE3C;IACI,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,gEAA+C;AACnD;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,WAAW,UAAU,EAAE;IACvB,MAAM,YAAY,EAAE;AACxB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB","sourcesContent":[".card {\n    border-radius: 12px;\n    z-index: 1;\n}\n\n.tableWrapper {\n    width: 100%;\n    overflow-x: auto;\n    border-radius: 8px;\n    max-height: 420px;\n    min-height: 200px;\n    overflow-y: scroll;\n}\n\n.mainTable {\n    width: 100%;\n    min-width: 1200px;\n    margin-bottom: 0;\n    border-collapse: separate;\n    border-spacing: 0;\n}\n\n.mainTable thead th {\n    background-color: var(--primary-blue-theme-color);\n    color: #ffffff;\n    font-size: 12px;\n    font-weight: 600;\n    text-align: center;\n    vertical-align: middle;\n    white-space: nowrap;\n    padding: 8px;\n    position: sticky;\n    top: 0;\n    z-index: 2;\n}\n\n.mainTable tbody td {\n    font-size: 12px;\n    text-align: center;\n    vertical-align: middle;\n    padding: 8px;\n    white-space: nowrap;\n}\n\n.mainTable tbody tr:hover td {\n    background-color: #f8fbff;\n}\n\n.badge {\n    display: inline-block;\n    padding: 2px 10px;\n    border-radius: 10px;\n    font-size: 11px;\n    font-weight: 600;\n}\n\n.badgeTrue {\n    color: #0f9d58;\n    background-color: #eafbf1;\n}\n\n.badgeFalse {\n    color: #d93025;\n    background-color: #fdecea;\n}\n\n.badgeValid {\n    color: #0f9d58;\n    background-color: #eafbf1;\n}\n\n.downloadBtn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n}\n\n/* =========================================\n   COLUMN HEADER FILTER (Engine / Ignition Status)\n========================================= */\n\n.thFilterWrap {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n}\n\n.thFilterSelect {\n    width: 100%;\n    max-width: 130px;\n    font-size: 11px;\n    font-weight: 500;\n    color: #1f2937;\n    background-color: #fff;\n    border: 1px solid #d7dee8;\n    border-radius: 4px;\n    padding: 3px 4px;\n    text-transform: none;\n    cursor: pointer;\n}\n\n.thFilterSelect:focus {\n    outline: none;\n    border-color: #2f7ed8;\n}\n\n/* =========================================\n   PAGINATION\n========================================= */\n\n.pageRow {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 10px;\n    padding: 10px 4px 2px;\n}\n\n.pageInfo {\n    font-size: 12px;\n    color: #6c757d;\n}\n\n.pageButtons {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.pageCurrent {\n    font-size: 12px;\n    color: #1f2937;\n    font-weight: 600;\n    min-width: 48px;\n    text-align: center;\n}\n\n/* =========================================\n   DISCLAIMER\n========================================= */\n\n.disclaimer {\n    margin-top: 8px;\n    padding: 6px 4px 2px;\n    font-size: 11px;\n    font-style: italic;\n    color: #9ca3af;\n    text-align: right;\n}\n\n.refreshDot {\n    display: inline-block;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    margin-right: 6px;\n    vertical-align: middle;\n    animation: refreshBlink 1s ease-in-out infinite;\n}\n\n.refreshDotGreen {\n    background: #28a745;\n    box-shadow: 0 0 6px #28a745;\n}\n\n.refreshDotRed {\n    background: #dc3545;\n    box-shadow: 0 0 6px #dc3545;\n}\n\n@keyframes refreshBlink {\n    0%, 100% { opacity: 1; }\n    50% { opacity: 0.2; }\n}\n\n.delayGreen {\n    color: #28a745;\n    font-weight: 600;\n}\n\n.delayRed {\n    color: #dc3545;\n    font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `TableING_card__TqgJk`,
	"tableWrapper": `TableING_tableWrapper__AZZGh`,
	"mainTable": `TableING_mainTable__ZvPUV`,
	"badge": `TableING_badge__F+tXV`,
	"badgeTrue": `TableING_badgeTrue__sfcMQ`,
	"badgeFalse": `TableING_badgeFalse__1+NPR`,
	"badgeValid": `TableING_badgeValid__eSZtj`,
	"downloadBtn": `TableING_downloadBtn__7vnGC`,
	"thFilterWrap": `TableING_thFilterWrap__DVv2q`,
	"thFilterSelect": `TableING_thFilterSelect__RuhKH`,
	"pageRow": `TableING_pageRow__kTUnM`,
	"pageInfo": `TableING_pageInfo__9cGlr`,
	"pageButtons": `TableING_pageButtons__UnTC5`,
	"pageCurrent": `TableING_pageCurrent__k5Wom`,
	"disclaimer": `TableING_disclaimer__JJmkT`,
	"refreshDot": `TableING_refreshDot__TVG09`,
	"refreshBlink": `TableING_refreshBlink__nn+Cf`,
	"refreshDotGreen": `TableING_refreshDotGreen__CB1G5`,
	"refreshDotRed": `TableING_refreshDotRed__rlUvF`,
	"delayGreen": `TableING_delayGreen__tKnuZ`,
	"delayRed": `TableING_delayRed__KxvU2`
};
export default ___CSS_LOADER_EXPORT___;
